import { Flex, FormControl, FormLabel, Text, } from '@chakra-ui/react';
import React from 'react';
const MaxLengthInputControl = ({ maxLength, label, length, children, ...rest }) => (React.createElement(FormControl, { ...rest },
    React.createElement(Flex, { justifyContent: "space-between", alignItems: "center" },
        React.createElement(FormLabel, { "data-testid": "max_length_input_control__label" }, label),
        length != null && (React.createElement(Text, { "data-testid": "max_length_input_control__limit_text", variant: "md-600-rg-4" },
            "(",
            length,
            " / ",
            maxLength,
            ")"))),
    children));
export default MaxLengthInputControl;
